import { combineReducers } from 'redux'
import { ui } from './ui'
import { app } from './app'
import { user } from './user'

export const rootReducer = combineReducers({ app, user, ui })
